import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DataTableResponse} from '../models/DatatableResponse';

@Injectable({
  providedIn: 'root'
})
export class PublicInstitutionsService {
  baseUrl = environment.baseUrl;
  public headers = new HttpHeaders();

constructor(private http: HttpClient) { }

getDataTableOptions(agents){
  const that = this;
  let headers;
  headers = this.headers.set('Content-Type', 'application/x-www-form-urlencoded');


  let options = {
    pagingType: 'full_numbers',
    pageLength: 10,
    serverSide: true,
    processing: true,
    language : {
      processing : '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> <div class="sk-bounce3"></div> </div>'
    },
    ajax: (dataTablesParameters: any, callback) => {
      that.http.post<DataTableResponse>(this.baseUrl + '/Facility/GetPublicInstitutions',$.param(dataTablesParameters), {headers: headers})
        .subscribe(
          resp => {
            agents.splice(0, agents.length)

            for(let ins of resp.data){
              agents.push(ins)
            }

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          },
          error => {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }
        );
    },

    columns: [{ data: '' }, { data: 'name' }, {data: 'phone'},{  data: 'email'}, {data: 'agentTypeName'}, {data: 'countryName'},{data: '', orderable: false}]
  }

  return options;
}

}
